/* eslint-disable max-len */
import {FILE_UPLOAD_TIMEOUT_MS} from '../../constants';
import {SERVICE_NAMES} from '../constants';
import {createApiCall, fetchAllPages} from '../utils';
import type {
    ApiCallOptions,
    PaginatedResponse,
    DocumentView,
    DocumentPageView,
    DocumentUpdateRequest,
    CloneDocumentRequest,
    DocumentsListParams,
    DocumentPageParams,
    DocumentPackageParams
} from './api.d';

export const documentApi = {
    getDocuments: (transactionId: string, params?: DocumentsListParams, options?: ApiCallOptions) => createApiCall<PaginatedResponse<DocumentView>>(SERVICE_NAMES.DOCUMENT, 'GET', `transactions/${transactionId}/documents`)({...options, params}),

    createDocuments: (transactionId: string, data: FormData, options?: ApiCallOptions) => createApiCall<DocumentView[]>(SERVICE_NAMES.DOCUMENT, 'POST', `transactions/${transactionId}/documents`)({timeout: FILE_UPLOAD_TIMEOUT_MS, ...options, data}),

    getDocument: (transactionId: string, documentId: string) => createApiCall<DocumentView>(SERVICE_NAMES.DOCUMENT, 'GET', `transactions/${transactionId}/documents/${documentId}`)({}),

    updateDocument: (transactionId: string, documentId: string, data: DocumentUpdateRequest, options?: ApiCallOptions) => createApiCall<DocumentView>(SERVICE_NAMES.DOCUMENT, 'PUT', `transactions/${transactionId}/documents/${documentId}`)({...options, data}),

    deleteDocument: (transactionId: string, documentId: string, options?: ApiCallOptions) => createApiCall<void>(SERVICE_NAMES.DOCUMENT, 'DELETE', `transactions/${transactionId}/documents/${documentId}`)({...options}),

    cloneDocument: (templateId: string, data: CloneDocumentRequest, options?: ApiCallOptions) => createApiCall<DocumentView[]>(SERVICE_NAMES.DOCUMENT, 'POST', `templates/${templateId}/clone`)({...options, data}),

    getDocumentPackage: (transactionId: string, params?: DocumentPackageParams, options?: ApiCallOptions) => createApiCall<Blob>(SERVICE_NAMES.DOCUMENT, 'GET', `transactions/${transactionId}/package`)({
        ...options,
        params,
        responseType: 'blob'
    }),

    getSignedDocument: (transactionId: string, documentId: string, options?: ApiCallOptions) => createApiCall<Blob>(SERVICE_NAMES.DOCUMENT, 'GET', `transactions/${transactionId}/documents/${documentId}/signed`)({
        ...options,
        responseType: 'blob',
        headers: {...options?.headers, Accept: 'application/pdf'}
    }),

    getOriginalDocument: (transactionId: string, documentId: string, options?: ApiCallOptions) => createApiCall<Blob>(SERVICE_NAMES.DOCUMENT, 'GET', `transactions/${transactionId}/documents/${documentId}/original`)({
        ...options,
        responseType: 'blob',
        headers: {...options?.headers, Accept: 'application/pdf'}
    }),

    getDocumentPageAsImage: (transactionId: string, documentId: string, pageIndex: number, params?: DocumentPageParams, options?: ApiCallOptions) => createApiCall<Blob>(SERVICE_NAMES.DOCUMENT, 'GET', `transactions/${transactionId}/documents/${documentId}/pages/${pageIndex}`)({
        ...options,
        params,
        responseType: 'blob'
    }),

    getDocumentPage: (transactionId: string, documentId: string, pageIndex: number) => createApiCall<DocumentPageView>(SERVICE_NAMES.DOCUMENT, 'GET', `transactions/${transactionId}/documents/${documentId}/pages/${pageIndex}/png`)({}),

    getAllDocuments: (transactionId: string, params?: Omit<DocumentsListParams, 'page'>, options?: ApiCallOptions) => fetchAllPages(
        (paginationParams, opts?: ApiCallOptions) => {
            const fullParams: DocumentsListParams = {
                ...paginationParams,
                ...(params || {})
            };
            return documentApi.getDocuments(transactionId, fullParams, opts);
        },
        {per_page: params?.per_page} as {page?: number; per_page?: number},
        options
    )
};
